export interface ILoginPayload {
  email: string;
  password: string;
}
export interface IResetPasswordPayload {
  email: string;
}

export enum UserRoleEnum {
  gvPersonnel = 'gvPersonnel',
  customerAdmin = 'customerAdmin',
  customerUser = 'customerUser',
  customerMngr = 'customerMngr',
}

export interface User {
  id: number;
  name: string;
  units: 'mpa' | 'psi';
  date_format: 'dmy' | 'mdy';
  time_format: '12h' | '24h';
  press_format: 'cube' | 'cylinder';
  email: string;
  role: UserRoleEnum;
  customer_id: number;
  email_notifications: boolean;
  sms_notifications: boolean;
  phone: string;
  reset_password_token: string | null;
  reset_password_token_expiry: string | null;
  created_at: string | null;
  updated_at: string;
  use_banana?: boolean;
  use_nfc?: boolean;
}

export interface ILoginResponse {
  user: User;
  access_token: string;
}

export interface UserSettingsItems {
  name: string;
  units: 'mpa' | 'psi';
  date_format: 'dmy' | 'mdy';
  time_format: '12h' | '24h';
  press_format: 'cube' | 'cylinder';
  phone: string;
  email: string;
  password?: string;
}

export interface IChangeSettingPayload extends UserSettingsItems {
  email_notifications: boolean;
  sms_notifications: boolean;
}
